export const parseJsonValue = (value: unknown): unknown => {
	if (typeof value !== 'string') {
		return value;
	}

	try {
		const parsed: unknown = JSON.parse(value);
		return parsed;
	} catch {
		return value;
	}
};
